<div class="teamsBox">
        <h4>{{ 'teams.configTab.title' | translate }}</h4>
        <p [innerHTML]="'teams.configTab.description' | translate"></p>
</div>